import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { EditProfileComponent } from "../../components/edit-profile/edit-profile.component";
import { AuthService } from '../../../../services/auth/auth.service';

@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [CommonModule, FormsModule, EditProfileComponent],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.css'
})
export class SettingsComponent implements OnInit {
  searchText: string = '';
  filteredTeam: any[] = [];
  isModalEditProfile: boolean = false;

  public username: string = '';
  public fullName: string | undefined = '';
  userInitials: string = '';
  userAccess: any[] = [];
  userEmail: string = '';
  public role = '';
  roleCode: string = '';
  regions: string[] = [];

  team = [
    {
      name: "Giovanni Izzo",
      role: "Super Admin",
      regions: ["tutte le regioni"],
      email: "giovanni.izzo@dimotma.com"
    },
    {
      name: "Francesca Pollarolo",
      role: "User",
      regions: ["Sicilia", "Puglia"],
      email: "francesca.pollarolo@dimotma.com"
    },
    {
      name: "Wilmer Rojas",
      role: "User",
      regions: ["Lombardia", "Emilia-Romagna"],
      email: "wilmer.rojas@dimotma.com"
    },
    {
      name: "Salvatore Pappalardo",
      role: "User",
      regions: ["Toscana", "Liguria"],
      email: "salvatore.pappalardo@dimotma.com"
    },
  ];

  constructor (private authService: AuthService) { }

  ngOnInit () {
    window.dispatchEvent(new CustomEvent('inWhichPage', { detail: "PROFILE" }));

    sessionStorage.setItem("medicineId", "")
    sessionStorage.setItem("solution", "Profile");
    this.username = sessionStorage.getItem('username') ?? '';
    const [firstName, lastName] = this.username.split('.').map(name =>
      name ? name.charAt(0).toUpperCase() + name.slice(1).toLowerCase() : ''
    );
    this.fullName = `${firstName} ${lastName || ''}`.trim();
    this.userInitials = this.getInitials(this.fullName);
    this.filteredTeam = this.team;

    this.authService.refreshUserData();
    const userData = this.authService.getUserData();
    /*if (userData) {
      this.userAccess = userData.roles || [];
      this.userEmail = userData.email;
      const { roleCode, roleLabel, regions } = this.extractRoleAndRegions(this.userAccess);
      this.role = roleLabel;
      this.roleCode = roleCode;
      this.regions = regions;
    }*/
  }

  extractRoleAndRegions (access: string[]): { roleCode: string; roleLabel: string; regions: string[] } {
    const roleLabels: Record<string, string> = {
      USERS: 'User',
      SUPERUSER: 'Super User',
      ADMIN: 'Admin'
    };

    const roles = ['ADMIN', 'SUPERUSER', 'USERS'];
    const roleCode = access.find(item => roles.includes(item)) || 'USERS';
    const roleLabel = roleLabels[roleCode] || roleCode;
    const regions = access.filter(item => !roles.includes(item));

    return { roleCode, roleLabel, regions };
  }

  getInitials (name: string): string {
    const nameParts = name.split(' ');
    const initials = nameParts.map(part => part.charAt(0)).join('').toUpperCase();
    return initials.length > 2 ? initials.substring(0, 2) : initials;
  }

  searchTeam () {
    if (!this.searchText) {
      this.filteredTeam = this.team;
    } else {
      this.filteredTeam = this.team.filter(user =>
        user.name.toLowerCase().includes(this.searchText.toLowerCase())
      );
    }
  }

  openEditProfile () {
    this.isModalEditProfile = true;
    document.body.style.overflow = 'hidden';
    document.body.style.width = '100%';
  }

  handleModalEditProfile (isOpen: boolean) {
    if (!isOpen) {
      this.isModalEditProfile = false;
      document.body.style.overflow = '';
      document.body.style.width = '';
    }
  }

  logout () {
    this.authService.logout();
  }
}
